/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type {
  VerifyCodeErrorResponse,
  VerifyCodeRequest,
  VerifyCodeSuccessResponse,
} from './api.schemas';

import { api } from '../util/http';

export const tfaVerify = (verifyCodeRequest: VerifyCodeRequest, signal?: AbortSignal) => {
  return api<VerifyCodeSuccessResponse>({
    url: `/api/auth/tfa/verify`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: verifyCodeRequest,
    signal,
  });
};

export const getTfaVerifyMutationOptions = <
  TError = VerifyCodeErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tfaVerify>>,
    TError,
    { data: VerifyCodeRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tfaVerify>>,
  TError,
  { data: VerifyCodeRequest },
  TContext
> => {
  const mutationKey = ['tfaVerify'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tfaVerify>>,
    { data: VerifyCodeRequest }
  > = (props) => {
    const { data } = props ?? {};

    return tfaVerify(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TfaVerifyMutationResult = NonNullable<Awaited<ReturnType<typeof tfaVerify>>>;
export type TfaVerifyMutationBody = VerifyCodeRequest;
export type TfaVerifyMutationError = VerifyCodeErrorResponse;

export const useTfaVerify = <TError = VerifyCodeErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof tfaVerify>>,
      TError,
      { data: VerifyCodeRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof tfaVerify>>,
  TError,
  { data: VerifyCodeRequest },
  TContext
> => {
  const mutationOptions = getTfaVerifyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
